import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

export const veilWrapperStyles: CSSObject = {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: constants.colors.ui.core[25],
  placeContent: "center",
  display: "flex",
};

export const childWrapperStyles: CSSObject = {
  filter: "blur(3px)",
};

export const bannerRootStyles: CSSObject = {
  "&&": {
    margin: "32px",
    borderRadius: "16px",
    width: "100%",
  },
};

export const bannerTitleStyles: CSSObject = {
  ...typographyStyles.heading3Obj,
};

export const bannerBodyStyles: CSSObject = {
  ...typographyStyles.textMObj,
};

export const iconStyles: CSSObject = {
  "--banner-visual-size-lg": "88px",
};
